<template lang="pug">
aside
  .cards.projection-panel
    BerRating
    EstimatedCostsCard
    BrAside(v-if="showBRPAside" :showActionButtons="showBRPActionButtons")
    LoanTypeCard(v-if="settings?.loanOptions && !hasCostsAndSavings")
    ProjectOutlayCard
    Loading(
        :active="!recommendationsPageLoading && isLoadingReport"
        :is-full-page="false"
        loader="dots"
        color="#fff"
        background-color="#000"
        :z-index="1000"
      )
  .buttons(v-if="actionButtonPos === ButtonPosition.AsideEnd || resetButtonPos === ButtonPosition.AsideEnd")
    ScheduleButton(v-if="actionButtonPos === ButtonPosition.AsideEnd")
    ResetRecommendationsButton(v-if="resetButtonPos === ButtonPosition.AsideEnd")
  Button.submit-button.costs-and-savings-button(v-if="hasCostsAndSavings" :label="$t('costsAndSavings.button')" @click="goToCostsAndSavings()")
</template>
<script lang="ts">
import { useSettings } from "@/store/settings";
import {computed, defineComponent} from "vue";
import BerRating from "./BerRating.vue";
import EstimatedCostsCard from "@/components/result/aside/EstimatedCostsCard.vue";
import LoanTypeCard from "@/components/result/aside/loan/LoanTypeCard.vue";
import ProjectOutlayCard from "@/components/result/aside/ProjectOutlayCard.vue";
import ScheduleButton from "@/components/result/ScheduleButton.vue";
import ResetRecommendationsButton from "@/components/result/recommendations/ResetRecommendationsButton.vue";
import Loading from "vue-loading-overlay";
import { useRecommendations } from "@/store/recommendations";
import { storeToRefs } from "pinia";
import { ButtonPosition, MenuDisplayOption } from "@/types";
import Button from "primevue/button";
import { useRouter } from "vue-router";
import BrAside from "@/components/result/br-passport/BrAside.vue";

export default defineComponent({
  name: "ResultAsidePanel",
  components: {
    BrAside,
    BerRating,
    EstimatedCostsCard,
    LoanTypeCard,
    ProjectOutlayCard,
    Loading,
    ScheduleButton,
    ResetRecommendationsButton,
    Button,
  },
  setup() {
    const { settings, hasCostsAndSavings } = storeToRefs(useSettings());
    const { recommendationsPageLoading, isLoadingReport } = storeToRefs(
      useRecommendations()
    );
    const actionButtonPos =
      settings.value?.recommendationsPageOptions?.actionButtonPosition;
    const resetButtonPos =
      settings.value?.recommendationsPageOptions?.actionButtonPosition;

    const router = useRouter();
    const currentRouteName = computed(() => router.currentRoute.value.name);
    function goToCostsAndSavings() {
      if (router.hasRoute("costs-and-savings")) {
        window.scrollTo(0, 0);
        router.push({ name: "costs-and-savings" });
      }
    }
    const hasBRP = computed(() => {
      const md = useSettings().settings?.recommendationsPageOptions?.menuDisplay
      return (md && Array.isArray(md) && md.find((i) => i === MenuDisplayOption.BRPassport))
    })
    const showBRPAside = computed(() => !!hasBRP.value)
    const showBRPActionButtons = computed(() => currentRouteName.value !== "brp")
    return {
      settings,
      recommendationsPageLoading,
      isLoadingReport,
      actionButtonPos,
      resetButtonPos,
      ButtonPosition,
      MenuDisplayOption,
      hasCostsAndSavings,
      goToCostsAndSavings,
      hasBRP,
      showBRPAside,
      showBRPActionButtons,
    };
  },
});
</script>
<style scoped lang="scss">
.projection-panel {
  position: relative;
  padding: 0;
  max-width: 95vw;
  background-color: $background-color-body;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.buttons {
  margin: 1.2rem 0;
  :deep(.p-button) {
    height: 3rem;
    margin-bottom: 0.75rem;
  }
}

.costs-and-savings-button {
  width: 100%;
  height: calc(3rem + 10px);
}

@media screen and (min-width: 1120px) {
  .projection-panel {
    width: 26vw;
    max-width: 30rem;
    height: fit-content;
  }
}
@media screen and (max-width: 1120px) and (min-width: 720px) {
  .projection-panel {
    display: grid;
    grid-template: 21rem 1fr / 25rem 1fr;
    gap: 0;
    row-gap: 0.25rem;
    width: 100%;
    max-width: 100%;
    padding: 0;

    > :deep(div) {
      border: 2px solid $background-color-body;
      .p-card-content {
        padding: 1rem;
      }

      &.loan {
        grid-row: 2/3;
        grid-column: 1/3;
      }

      &.project-outlay {
        grid-row: 2/3;
        grid-column: 2/3;
        height: fit-content;
        z-index: 99;
      }

      &.brp-aside {
        grid-column: 1/3;
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 1120px) and (min-width: 720px) {
  .projection-panel {
    grid-template: 21rem 1fr / 22rem 1fr;
  }
}
</style>
